import { ADD_VARIANT } from '../actions/constants';

export const initialState = { guidedChecklistVariant: null };

const marketingToolsExperimentVariant = (state = initialState, action) => {
    if (action.type === ADD_VARIANT) {
        return { ...state, guidedChecklistVariant: action.variant || null };
    }

    return state;
};

export default marketingToolsExperimentVariant;
